<template>
  <div class="field">
    <label
      class="label"
      :for="inputId"
    >{{ label }}</label>
    <div class="file has-name">
      <label class="file-label">
        <input
          :id="inputId"
          ref="input"
          v-bind="$attrs"
          @change="changeFile"
          class="file-input"
          :class="{ 'is-danger': hasError }"
          type="file"
          :multiple="multiple"
        />
        <span class="file-cta">
          <span class="file-label">{{ buttonLabel }}</span>
        </span>
        <span
          v-if="fileName"
          class="file-name"
        >{{ fileName }}</span>
      </label>
    </div>
    <p
      class="help is-danger"
      v-if="hasError"
    >{{ error[0] }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

/** File input */
export default defineComponent({
  props: {
    /** The input value, a list of files */
    modelValue: FileList,
    /** Label for the field */
    label: String,
    /** Array of error messages */
    error: Object,
    /** does not do anything */
    isLoading: Boolean,
    /** ID assigned to the input if present, otherwise uses the label */
    htmlId: String,
    /** Set to true to allow to select multiple files */
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonLabel() {
      if (this.multiple) {
        return 'Choose files...'
      } else {
        return 'Choose a file...'
      }
    },
    hasError() {
      return this.error !== undefined
    },
    inputId() {
      if (this.htmlId === undefined) {
        if (this.label === undefined) {
          return null
        }
        return this.label.replaceAll(" ", "-").toLowerCase()
      } else {
        return this.htmlId
      }
    }
  },
  data() {
    return {
      fileName: null as string | null
    }
  },
  methods: {
    changeFile(event: any) {
      this.$emit('update:modelValue', event.target.files)
      if (event.target.files.length === 1) {
        this.fileName = event.target.files[0].name
      } else if (event.target.files.length > 1) {
        this.fileName = `${event.target.files[0].name} and ${event.target.files.length - 1} other files`
      } else {
        this.fileName = null
      }
    }
  }
})
</script>